var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.73 16.04L12.115.962C11.776.369 11.157 0 10.5 0c-.657 0-1.276.369-1.616.963L.271 16.039c-.351.614-.362 1.383-.028 2.008.334.624.964 1.012 1.643 1.012h17.228c.68 0 1.309-.388 1.643-1.012.334-.625.323-1.394-.028-2.008zm-1.164 1.297c-.092.172-.265.279-.452.279H1.886c-.187 0-.36-.107-.452-.279-.092-.172-.09-.384.007-.552l8.614-15.077c.094-.163.264-.265.445-.265.18 0 .351.102.445.265l8.614 15.077c.096.169.099.38.007.552z",
    transform: "translate(-20 -374) translate(20 374) translate(0 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.506 6.625c-.52 0-.926.28-.926.774 0 1.51.178 3.679.178 5.188 0 .393.342.558.748.558.305 0 .736-.165.736-.558 0-1.51.178-3.678.178-5.188 0-.495-.419-.774-.914-.774zM10.52 14.02c-.559 0-.978.444-.978.977 0 .52.419.977.977.977.52 0 .964-.457.964-.977 0-.533-.444-.977-.964-.977z",
    transform: "translate(-20 -374) translate(20 374) translate(0 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertas);
export default __webpack_public_path__ + "static/media/alertas.364058cd.svg";
export { ForwardRef as ReactComponent };